import {
  Box,
  Card,
  List,
  ListSubheader,
  ListItem,
  Sheet,
  IconButton
} from '@mui/joy';
import { 
  Instagram, 
  Email
} from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Link } from '@mui/material';
import logo from '../img/TKGlogo.png';

export const Footer = () => {
  return (
    <Sheet
      variant="solid"
      invertedColors
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 2,
        backgroundColor: '#ff9800',
        borderRadius: 'sm',
        height: 'auto',
      }}
    >
      {/* ロゴセクション */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Card
          variant="soft"
          size="sm"
          sx={{
            backgroundColor: 'transparent',
            boxShadow: 'none',
            borderRadius: 'sm',
            p: 1,
          }}
        >
          <img alt="logo" src={logo} width={80} height={80} />
        </Card>
      </Box>

      {/* フッターコンテンツ */}
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 4 }}>

        {/* ソーシャルメディアアイコン */}
        <Box>
          <List
            size="sm"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              justifyContent: 'center',
            }}
          >
            <ListItem sx={{ paddingLeft: 0 }}>
              <ListSubheader sx={{ color: 'white', fontWeight: 'xl' }}>
                Follow Us
              </ListSubheader>
            </ListItem>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <a href="https://www.instagram.com/tkg_basketball" target="_blank" rel="noopener noreferrer">
                <IconButton sx={{ color: 'white' }}>
                  <Instagram />
                </IconButton>
              </a>
              <a href="mailto:tkg.basketball@gmail.com?subject=【TKG予約システム】お問い合わせ&body=問い合わせ内容：" target="_blank" rel="noopener noreferrer">
                <IconButton sx={{ color: 'white' }}>
                  <Email />
                </IconButton>
              </a>
            </Box>
          </List>
        </Box>
      </Box>

      {/* フッター下部 */}
      <Box
        sx={{
          mt: 3,
          textAlign: 'center',
          color: 'white',
          fontSize: '0.8rem',
        }}
      >
        <Typography variant="body1" sx={{ color: 'white', fontWeight: 'bold' }}>
          TKG Basketball
        </Typography>
        <Typography variant="body2" color="inherit">
          © 2025 Copel Inc. All rights reserved.
        </Typography>
        <Link
          component={RouterLink}
          to="/legal-notice"
          underline="hover"
          sx={{ color: 'white', fontSize: '0.75rem', mt: 1, display: 'block' }}
        >
          特定商取引法に基づく表記
        </Link>
      </Box>
    </Sheet>
  );
};
